






































import { Vue, Component } from 'vue-property-decorator';
import SCAToolbar from '@/SCAToolbar.vue';
import Welcome from '@/Welcome.vue';
import AppMenu from '@/AppMenu.vue'
import { auth } from './auth/AuthService';
import router from './router';

import BOX_QUERY from './graphql/Box.graphql';
import PROJECT_QUERY from './graphql/Project.graphql';

declare var USE_AUTH;

@Component({
  name: 'app',
  components: {
    SCAToolbar,
    AppMenu,
    Welcome,
  },
})
export default class App extends Vue {

  created() {
    // Check if authenticated, unless we are currently in the auth callback
    console.log(`USE_AUTH`, USE_AUTH);

    // console.log(`router`, router);
    const route = router.currentRoute.name;
    if (route !== 'AuthCallback') {
      auth.init();
    }
  }

  mounted() {
    console.log(`[App] mounted`);
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue